<template>
    <fade-up-animation :element="() => $refs.section" :y-from="15">
        <nav
            class="secondary-nav-bar"
            :aria-label="$snippet('secondary_navigation', 'Secondary navigation')"
            ref="section"
        >
            <ul>
                <li
                    v-for="item in menuItems"
                    :key="item.name"
                >
                    <b-button
                        :to="item.to"
                        variant="primary"
                        size="sm"
                        class="nav-item"
                        v-test:navBtn
                    >
                        {{ item.name }}
                    </b-button>
                </li>
            </ul>
        </nav>
    </fade-up-animation>
</template>

<script>
    export default {
        name: 'secondary-nav-bar',

        props: {
            menuItems: {
                type: Array,
                default: () => ([]),
            },
        },
    };
</script>

<style lang="scss" scoped>
    $gap: 10px;

    .secondary-nav-bar {
        padding: 16px 20px;
        background-color: secondary-palette(7);
    }

    .nav-item.btn {
        padding-left: 2px;
        padding-right: 2px;
        min-width: unset;
        width: 100%;
        font-size: rem(14px);

        @include media-breakpoint-up(md) {
            padding: $btn-padding-y $btn-padding-x;
            font-size: rem(16px);
        }
    }

    ul {
        margin: 0;
        list-style: none;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0;
        flex-wrap: wrap;
        gap: $gap;
    }

    li {
        flex-basis: calc(50% - #{$gap / 2});

        @include media-breakpoint-up(md) {
            flex-basis: 0;
            flex-grow: 1;
            max-width: 200px;
        }
    }
</style>
